export const TWITTER_SHARE_ORIGIN = "https://twitter.com/intent/tweet";
export const LINE_SHARE_ORIGIN = "https://social-plugins.line.me/lineit/share";
export const HASH_TAG_ENCODE = "%23";
